import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom"
import "../styles/portal/ShapeManager.css"
import { getDeviceMaps, newShapefileAPIPost } from "../aws/Api.js"
import { getAuthUser, uploadFile, uploadFileWithProgress } from "../aws/Authentication";
import { PortalContext } from "../Portal"
import EmConstrucao from "../EmConstrucao.jsx";
import Botao from "../utils/Botao.jsx";

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

function sumSizes(files) {
  let total = 0;
  for (const f of files) total += f.size || 0;
  return total || 1;
}

function ShapeManager() {
    const ref = useRef(null);
    const [ shapefiles, setShapeFiles ] = useState();
    const [ nivelPermissao, setNivelPermissao ] = useState([]);
    const navigate = useNavigate()
    const { user, setShapefile, setShpData, setDbfData, } = useContext(PortalContext);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0); // 0..100
    const [status, setStatus] = useState("");

    useEffect(() => {
      getShapeFiles();
    }, []);

    const getShapeFiles = () => {
        getDeviceMaps(user.attributes.sub, "all")
        .then(res => {
            if(!res.ok) throw Error("Não conseguiu buscar");
            return res.json();
        })    
        .then(data => {
            setShapeFiles(data);
            // console.log("getDeviceMaps = ", data);
        })
        .catch(err => {
            console.log(`erro ${err}`);
        });
    }

    const handleOnClickVoltar = () => {
        navigate("/portal/home");
    }

    const handleOnClickViewMap = (shape) => {
        setShapefile(shape);
        setShpData(null);
        setDbfData(null);
        // console.log("setando shape ", shape);
        navigate("/portal/mapas-detalhe");
    }

    const handleFileLoadOld = () => {
        console.log("Files = ", ref.current.files);
        //verifica os nomes        
        if (ref.current.files.length < 3) {
            console.log("Faltando arquivos");
            return;
        }
        const nome1 = ref.current.files[0].name.split(".");
        console.log("nome 1 é do tipo = ", typeof(nome1));
        const nome2 = ref.current.files[1].name.split(".");
        const nome3 = ref.current.files[2].name.split(".");
        
        let temDbf;
        let temShx;
        let temShp;
        if ((nome1[0] === nome2[0]) && (nome1[0] === nome3[0])) {
            console.log("nomes batem");
            if ((nome1[1] === 'dbf') || (nome2[1] === 'dbf') || (nome3[1] === 'dbf')) {
                temDbf = true;
            }
            if ((nome1[1] === 'shx') || (nome2[1] === 'shx') || (nome3[1] === 'shx')) {
                temShx = true;
            }
            if ((nome1[1] === 'shp') || (nome2[1] === 'shp') || (nome3[1] === 'shp')) {
                temShp= true;
            }
            if (!temDbf) {
                console.log("falta dbf");
            } else if (!temShx) {
                console.log("falta shx");
            } else if (!temShp) {
                console.log("falta shp");
            } else {
              console.log("Tudo certo");
              const shapefileUUID = uuidv4();
              getAuthUser().then(authUserResp => {
                if (authUserResp === null) {
                  console.log("Não tem usuario logado resp = ", authUserResp);
                  return;
                }
                else {
                  console.log("OK usuario ", authUserResp.attributes.sub, " logado"); //authUserResp.attributes.email
                  //OK Fazer upload
                  uploadFile(shapefileUUID + '.' + nome1[1], ref.current.files[0])
                  .then((resp) => {
                    console.log("resp=", resp);
                    uploadFile(shapefileUUID + '.' + nome2[1], ref.current.files[1])
                    .then((resp) => {
                      console.log("resp=", resp);
                      uploadFile(shapefileUUID + '.' + nome3[1], ref.current.files[2])
                      .then((resp) => {
                        console.log("resp=", resp);
                        //se deu certo o upload dos 3 arquivos, insere no DB
                        let idsAcesso = "";
                        // if (!nivelPermissao)
                        //   idsAcesso = device.deviceID;
                        newShapefileAPIPost(authUserResp.attributes.sub, shapefileUUID, idsAcesso, nome1[0])
                        .then((resp) => {
                          console.log("resp da API de newshapefile", resp);
                          getShapeFiles();
                        });
                      });
                    });
                  });
                }
              });
            }
        } else {
            console.log("arquivos com nomes diferentes");
        }
    };

    const handleFileLoad = async () => {
        const files = Array.from(ref.current.files || []);
        if (files.length < 3) return;

        const nome1 = ref.current.files[0].name.split(".");
        console.log("nome 1 é do tipo = ", typeof(nome1));
        const nome2 = ref.current.files[1].name.split(".");
        const nome3 = ref.current.files[2].name.split(".");
        
        let temDbf;
        let temShx;
        let temShp;
        if ((nome1[0] === nome2[0]) && (nome1[0] === nome3[0])) {
            console.log("nomes batem");
            if ((nome1[1] === 'dbf') || (nome2[1] === 'dbf') || (nome3[1] === 'dbf')) {
                temDbf = true;
            }
            if ((nome1[1] === 'shx') || (nome2[1] === 'shx') || (nome3[1] === 'shx')) {
                temShx = true;
            }
            if ((nome1[1] === 'shp') || (nome2[1] === 'shp') || (nome3[1] === 'shp')) {
                temShp= true;
            }
            if (!temDbf) {
                console.log("falta dbf");
            } else if (!temShx) {
                console.log("falta shx");
            } else if (!temShp) {
                console.log("falta shp");
            } else {
                console.log("Tudo certo");
                const shapefileUUID = uuidv4();

                const authUserResp = await getAuthUser();
                if (!authUserResp) return;

                setUploading(true);
                setProgress(0);
                setStatus("Preparando upload...");

                // Mapeia extensões e ordena por ext (opcional)
                const f1 = files[0];
                const f2 = files[1];
                const f3 = files[2];

                const totalBytes = sumSizes([f1, f2, f3]);
                const sent = { b1: 0, b2: 0, b3: 0 };

                const updateTotal = () => {
                    const totalSent = sent.b1 + sent.b2 + sent.b3;
                    setProgress(Math.min(100, (totalSent / totalBytes) * 100));
                };

                try {
                    // Upload 1
                    setStatus(`Enviando ${f1.name}...`);
                    await uploadFileWithProgress(`${shapefileUUID}.${f1.name.split(".").pop()}`, f1, (pct) => {
                    sent.b1 = (pct / 100) * (f1.size || 0);
                    updateTotal();
                    });

                    // Upload 2
                    setStatus(`Enviando ${f2.name}...`);
                    await uploadFileWithProgress(`${shapefileUUID}.${f2.name.split(".").pop()}`, f2, (pct) => {
                    sent.b2 = (pct / 100) * (f2.size || 0);
                    updateTotal();
                    });

                    // Upload 3
                    setStatus(`Enviando ${f3.name}...`);
                    await uploadFileWithProgress(`${shapefileUUID}.${f3.name.split(".").pop()}`, f3, (pct) => {
                    sent.b3 = (pct / 100) * (f3.size || 0);
                    updateTotal();
                    });

                    setStatus("Registrando no banco...");
                    const idsAcesso = "";
                    await newShapefileAPIPost(authUserResp.attributes.sub, shapefileUUID, idsAcesso, f1.name.split(".")[0]);

                    setStatus("Concluído!");
                    setProgress(100);
                    await getShapeFiles();

                } catch (err) {
                    console.error(err);
                    setStatus("Falha no upload.");
                } finally {
                    setUploading(false);
                }
            }
        }        
    };


    return (
        <div className="shape-manager-container">
            <div className="shape-manager-tittle-container">
                {/* <button className="shape-manager-tittle-button" onClick={() => handleOnClickVoltar()}>Voltar</button> */}
                <Botao handleOnClick={() => handleOnClickVoltar()} estilo={{"width":"100px"}}>Voltar</Botao>
                <span className="tittle">Gerenciador de Mapas</span>
            </div>
            <div className="shape-manager-content-container">
                <div className="shape-manager-table-container">
                    <table className="shape-manager-table">
                    <thead className="shape-manager-table-head">
                        <tr className="shape-manager-table-row">
                        <td className="shape-manager-table-index">#</td>
                        <td className="shape-manager-table-filename">Meus mapas</td>
                        <td className="shape-manager-table-viewbtn" />
                        </tr>
                    </thead>
                    <tbody className="shape-manager-table-body">
                        {shapefiles && shapefiles.map((file,i) => (
                        <tr className="shape-manager-table-body-row" key={file.shapefileUUID}>
                            <td className="shape-manager-table-index">{i+1}</td>
                            <td className="shape-manager-table-filename">{file.filename}</td>
                            <td className="shape-manager-table-viewbtn">
                                <button onClick={() => handleOnClickViewMap(file)}>Visualizar</button>
                            </td>
                        </tr>
                        ))}
                        <tr className="shape-manager-table-body-row">
                        <td>Novo Mapa</td>
                        <td>
                            <input
                                style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer"
                                    }}
                                ref={ref} 
                                type="file" 
                                multiple='multiple' 
                                onChange={handleFileLoad} />
                            <div
                                style={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "2px dashed #999",
                                borderRadius: "8px",
                                background: "#f8f8f8",
                                fontWeight: "bold"
                                }}
                            >
                                Clique ou arraste os arquivos aqui
                            </div>
                        </td>
                        <td>
                            {/* <label>permissão:</label>
                            <select>
                            <option value={false}>Apenas para este</option>
                            <option value={true}>Para todos</option>
                            </select> */}
                        </td>
                        </tr>
                        <tr className="shape-manager-table-body-row">
                            {/* <div style={{ marginTop: 12 }}>
                                <div>Enviando sajhdfisajhf.dbf...</div>
                                <progress value="99" max="100" style={{ width: "100%" }} />
                                <div>99%</div>
                            </div> */}
                            {uploading && (
                                <div style={{ marginTop: 12 }}>
                                    <div>{status}</div>
                                    <progress value={progress} max="100" style={{ width: "100%" }} />
                                    <div>{progress.toFixed(0)}%</div>
                                </div>
                                )}
                        </tr>
                    </tbody>
                    </table>
                </div>
                {/* <div className="shape-manager-buttons-container">
                    <button className="shape-manager-button">
                        Carregar Novo Mapa
                    </button>
                </div> */}
            </div>
        </div>
    )
}

export default ShapeManager
